
function BlogComponent(props) {
    return (
        <article>
            <h2><a href={props.link} target="_blank" rel="noopener noreferrer">
                {props.title}
            </a></h2>
            <p><time datetime="{props.date}">{props.date}</time> · {props.username}</p>
        </article>
    );
}

export default BlogComponent;